module.exports = __webpack_public_path__ + "logo-nl-3673cca6c6f18d2288e2.png";